module.exports = __webpack_public_path__ + "static/media/ci-4.8224b879.jpg";